import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// ✅ FIXED BASE URL (NO /api)
const BASE_URL =
  process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";

const API = `${BASE_URL}/other-medical`;

// ================= ERROR HELPER =================
const getError = (err) =>
  err?.response?.data?.message ||
  err?.message ||
  "Something went wrong";

// ================= CREATE / UPDATE =================
export const saveOtherMedicalAvailability = createAsyncThunk(
  "other/save",
  async ({ data, token }, { rejectWithValue }) => {
    try {
      const res = await axios.post(API, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(getError(err));
    }
  }
);

// ================= GET ALL =================
export const getOtherMedicalAvailability = createAsyncThunk(
  "other/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(API);
      return res.data;
    } catch (err) {
      return rejectWithValue(getError(err));
    }
  }
);

// ================= GET BY USER =================
export const getOtherMedicalByUser = createAsyncThunk(
  "other/getByUser",
  async ({ id, token }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(getError(err));
    }
  }
);

// ================= DELETE =================
export const deleteOtherMedicalAvailability = createAsyncThunk(
  "other/delete",
  async ({ id, token }, { rejectWithValue }) => {
    try {
      await axios.delete(`${API}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return id;
    } catch (err) {
      return rejectWithValue(getError(err));
    }
  }
);

// ================= CHECK =================
export const checkOtherMedicalAvailability = createAsyncThunk(
  "other/check",
  async ({ data, token }, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${API}/check`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(getError(err));
    }
  }
);

// ================= SLICE =================
const otherMedicalSlice = createSlice({
  name: "otherMedicalAvailability",
  initialState: {
    list: [],
    single: null,
    check: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // ✅ SUCCESS
      .addCase(getOtherMedicalAvailability.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })

      .addCase(getOtherMedicalByUser.fulfilled, (state, action) => {
        state.loading = false;
        state.single = action.payload;
      })

      .addCase(deleteOtherMedicalAvailability.fulfilled, (state, action) => {
        state.loading = false;
        state.list = state.list.filter(
          (i) => i._id !== action.payload
        );
      })

      .addCase(checkOtherMedicalAvailability.fulfilled, (state, action) => {
        state.loading = false;
        state.check = action.payload;
      })

      // ✅ GLOBAL PENDING
      .addMatcher(
        (action) =>
          action.type.startsWith("other/") &&
          action.type.endsWith("/pending"),
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )

      // ✅ GLOBAL ERROR
      .addMatcher(
        (action) =>
          action.type.startsWith("other/") &&
          action.type.endsWith("/rejected"),
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        }
      );
  },
});

export default otherMedicalSlice.reducer;
